import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { InformacionClienteModal } from "./informacionclientemodal";
const EditModal = InformacionClienteModal;

interface ResumenGuia {
    NombreSucursalOrigen: string;
    NombreSucursalDestino: string;
    Status: models.StatusGuia;
    EsDeAcuse: boolean;
    FolioGuiaAcuse: string;
    Folio: string;
    CantidadPaquetes: number;
    CantidadSobres: number;
    NombreSucursalStatus: string;
}

interface ResumenGuiaViewProps {
    value: ResumenGuia;
    puedeVerDatosEntregaCliente?: boolean;
}

export class ResumenGuiaView extends React.PureComponent<ResumenGuiaViewProps> {
    private modals = kea.createModalManager();

    puedeVerDatosCliente = (x: ResumenGuiaViewProps) => x.puedeVerDatosEntregaCliente;

    private InformacionClienteRecibio = async () => {
        var guia = this.props.value
        var informacion = await resources.Rastreo.ObtenerInformacionCliente(guia.Folio);
        const result = await this.modals.showModal(EditModal, undefined, informacion);
    }

    render() {
        const value = this.props.value;
        const puedeVerbotonInfoCliente = this.puedeVerDatosCliente(this.props)
        return (
            <div>
                {
                    (models.StatusGuia.EntregadaOcurre == value.Status || models.StatusGuia.EntregadaDomicilio == value.Status || models.StatusGuia.EntregadaZonaExtendida == value.Status) &&
                    <span style={{ fontSize: "20px" }}>
                        Entregada al cliente
                        {' '}
                        {
                            puedeVerbotonInfoCliente &&
                            <kea.IconButton
                                tooltip="Ver información del cliente que recibió"
                                iconClass={fa("info-circle")}
                                style="primary"
                                children="Ver firma"
                                onClick={this.InformacionClienteRecibio}
                            />
                        }
                    </span>
                }
                <br />
                <span style={{ fontSize: "25px" }}>
                    <span style={{ fontFamily: "monospace", fontWeight: "bold" }}>
                        {value.NombreSucursalOrigen} <i className={fa("arrow-right", "fw")} /> {value.NombreSucursalDestino}
                    </span>
                    {" "}
                    <span className="label label-info" >
                        {models.StatusGuia[value.Status]}
                    </span>
                    {
                        value.EsDeAcuse &&
                        <span className="label label-danger" >
                            <span style={{ fontFamily: "monospace", fontWeight: "bold" }}>
                                Acuse de {value.FolioGuiaAcuse}
                            </span>
                        </span>
                    }
                </span>

                <br />
                <span style={{ fontStyle: "italic" }}>
                    {value.CantidadPaquetes == 0 ? "" : value.CantidadPaquetes == 1 ? ("Un paquete ") : (value.CantidadPaquetes + " paquetes")}
                    {value.CantidadSobres == 0 ? "" : value.CantidadSobres == 1 ? (", un sobre") : (", " + value.CantidadSobres + " sobres.")}
                </span>

                <br />
                {
                    value.NombreSucursalStatus &&
                    <span style={{ fontSize: "20px" }}>
                        Sucursal actual:
                            <span style={{ fontFamily: "monospace", fontWeight: "bold" }}>
                            {value.NombreSucursalStatus}
                        </span>
                    </span>
                }

                {this.modals.component}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/componentes/guia/resumenguia.tsx